import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Select from 'react-select';
import FroalaEditor from 'react-froala-wysiwyg'; // Global States for faster scheduling

import { useStore } from "../../contexts/store";
// Components
import Checkbox from "../../components/Checkbox";
import { TagsInput } from "../../components/Autocomplete"; // API and helpers

import formatDateTime from "../../helpers/zoomHelpers/formatDateTime";
import updateSchedule from "../../helpers/scheduleHelpers/updateSchedule";
import { employeeApi } from '@atheneum/api';
import { shouldHideExpertInfo } from '@atheneum/api/dist/lib';
import { validateAdditionalEmails } from "../../helpers/expertHelpers";
export const SendInviteClient = () => {
  const {
    state,
    dispatch
  } = useStore();
  const {
    availabilityStore_imp,
    clientMessage,
    schedule,
    zoomLocationClient,
    activeTeams,
    selectedTeam,
    additionalEmailsClient,
    clientSubject,
    showSkipClient,
    clientContacts,
    lastPath,
    quickInviteClient,
    sendZoomUpdateClient,
    clientInvited,
    clientContactOptions,
    meetingType,
    locationClient,
    dayToRender,
    opsTime,
    duration,
    attachExpertScreeningQuestions,
    attachExpertProfilePdf
  } = state;
  const {
    EMPLOYEE_POSITIONS
  } = availabilityStore_imp.staticData.CONST;
  const employeePositions = [EMPLOYEE_POSITIONS.ASSOCIATE, EMPLOYEE_POSITIONS.TEAM_LEADER, EMPLOYEE_POSITIONS.ACCOUNT_MANAGER, EMPLOYEE_POSITIONS.PRINCIPAL];
  const {
    project
  } = availabilityStore_imp || {};
  const hidden = shouldHideExpertInfo(project); // TODO: replace with cascading setting, once ready

  const [isFocused, setIsFocused] = useState(false);

  const onFocus = () => {
    setIsFocused(true);
  };

  const onBlur = () => {
    setIsFocused(false);
  };

  const focused = isFocused ? 'rich-text-wrapper--focused rich-text-wrapper--toolboxActive' : '';
  const config = {
    key: process.env.REACT_APP_FROALA_KEY,
    quickInsertTags: [],
    charCounterCount: false,
    linkInsertButtons: [],
    toolbarButtons: ['paragraphFormat', '|', 'formatOL', 'formatUL', '|', 'insertLink', '|', 'clearFormatting', 'underline', 'italic', 'bold'],
    htmlAllowedStyleProps: ['text-align', 'font-size', 'width', 'height', 'vertical-align', 'font-weight', 'font-style', 'text-decoration', 'display', 'direction', 'letter-spacing', 'word-spacing'],
    htmlAllowedAttrs: ['id', 'href', 'contenteditable'],
    events: {
      'froalaEditor.focus': onFocus,
      'froalaEditor.blur': onBlur
    },
    linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove']
  };
  const screeningSupported = !hidden && (clientMessage || '').includes('id="screening"');
  const pdfAttachSupported = !hidden && (clientMessage || '').includes('id="expert-pdf"'); // Update schedule with the latest value when opsTime changes

  useEffect(() => {
    if (opsTime) {
      const {
        newTimeslot,
        newAvailabilities
      } = updateSchedule(dayToRender, opsTime, duration);
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            timeslots: [newTimeslot],
            availabilities: [...schedule.availabilities, ...newAvailabilities]
          }
        }
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [opsTime]); // NOTE: fieldsHiddenToExpert is badly named, it controls which EPL fields
  // can be seen by a client

  const fieldsHiddenToExpert = JSON.parse(availabilityStore_imp.epl.fieldsHiddenToExpert || '"[]"');
  const isScreeningQuestionsHiddenFromClient = hidden || fieldsHiddenToExpert.includes('screening'); // Don't allow attachExpertScreeningQuestions  if,

  const allowAttachExpertScreeningQuestions = !!( // (1) there is no screening text set for the EPL
  availabilityStore_imp.epl && availabilityStore_imp.epl.screening && availabilityStore_imp.epl.screening.length > 0 && // (2) or the field is set to be hidden from the client
  !isScreeningQuestionsHiddenFromClient);
  let isExpertPdfChecked = !hidden && attachExpertProfilePdf;
  let isScreeningChecked = !hidden && attachExpertScreeningQuestions;
  useEffect(() => {
    let defaultClientText = clientMessage.slice();
    defaultClientText = setInnerHtmlFromText(defaultClientText, '#additional-text', ''); //setup state for initial client invite send

    if (!clientInvited) {
      if (!allowAttachExpertScreeningQuestions) {
        isScreeningChecked = false;
        defaultClientText = setInnerHtmlFromText(defaultClientText, '#screening', '');
      } else {
        isScreeningChecked = true;
      } //setup state for client invite reschedule

    } else {
      // if not allowed, disable checkbox and remove handlebar
      if (!allowAttachExpertScreeningQuestions) {
        isScreeningChecked = false;
        defaultClientText = setInnerHtmlFromText(defaultClientText, '#screening', ''); // otherwise check if isScreeningChecked was previously set or not
      } else {
        const div = document.createElement('div');
        div.innerHTML = defaultClientText;
        const element = div.querySelector('#screening');

        if (element) {
          const html = element.innerHTML; // isScreeningChecked was previously set

          if (!!(!html.length != !(html === '<br>'))) {
            isScreeningChecked = true;
            defaultClientText = setInnerHtmlFromText(defaultClientText, '#screening', '{{{screeningQuestions}}}');
            defaultClientText = setInnerHtmlFromText(defaultClientText, '#additional-text', '{{{additionalText}}}'); // isScreeningChecked was previously not set
          } else {
            isScreeningChecked = false;
            defaultClientText = setInnerHtmlFromText(defaultClientText, '#screening', '');
          }
        }
      } // check if isExpertPdfChecked was previously set


      const div = document.createElement('div');
      div.innerHTML = defaultClientText;
      const element = div.querySelector('#expert-pdf');

      if (element) {
        const html = element.innerHTML; // isExpertPdfChecked was previously set

        if (!!(!html.length != !(html === '<br>'))) {
          isExpertPdfChecked = true;
          defaultClientText = setInnerHtmlFromText(defaultClientText, '#expert-pdf', '{{{expertPdfAttachment}}}');
          defaultClientText = setInnerHtmlFromText(defaultClientText, '#additional-text', '{{{additionalText}}}'); // isExpertPdfChecked was previously not set
        } else {
          isExpertPdfChecked = false;
          defaultClientText = setInnerHtmlFromText(defaultClientText, '#expert-pdf', '');
        }
      }
    }

    dispatch({
      type: 'UPDATE',
      payload: {
        attachExpertScreeningQuestions: isScreeningChecked,
        attachExpertProfilePdf: isExpertPdfChecked,
        clientMessage: defaultClientText
      }
    });
  }, []);
  const initClientText = clientMessage.slice();
  const [clientText, setClientText] = useState(clientMessage.slice());
  const additionalTextRequired = isScreeningChecked || isExpertPdfChecked;
  useEffect(() => {
    let screeningText = '';

    if (isScreeningChecked) {
      screeningText = '{{{screeningQuestions}}}';
    }

    const updatedClientText = setInnerHtml(screeningText, '#screening') || clientMessage;
    setClientText(updatedClientText);
  }, [clientMessage, isScreeningChecked]);
  useEffect(() => {
    let additionalText = '';

    if (additionalTextRequired) {
      additionalText = '{{{additionalText}}}';
    }

    const updatedClientText = setInnerHtml(additionalText, '#additional-text') || clientMessage;
    setClientText(updatedClientText);
  }, [clientMessage, additionalTextRequired]);
  useEffect(() => {
    let expertPdfText = '';

    if (isExpertPdfChecked && !hidden) {
      expertPdfText = '{{{expertPdfAttachment}}}';
    }

    const updatedClientText = setInnerHtml(expertPdfText, '#expert-pdf') || clientMessage;
    setClientText(updatedClientText);
  }, [clientMessage, hidden, isExpertPdfChecked, project]);

  function setInnerHtml(newHtml, selector) {
    const element = document.querySelector(selector);

    if (element) {
      element.innerHTML = newHtml;
      const parent = element.parentElement;
      return parent.innerHTML;
    }

    return false;
  }

  function setInnerHtmlFromText(text, selector, newHtml) {
    const div = document.createElement('div');
    div.innerHTML = text;
    const element = div.querySelector(selector);

    if (element) {
      element.innerHTML = newHtml;
    } else {
      return text;
    }

    return div.innerHTML;
  }

  const additionalEmailsValid = !(additionalEmailsClient && additionalEmailsClient.find(email => email.invalid));
  const formIsValid = Boolean(additionalEmailsValid && selectedTeam);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", null, "Invite client(s)"), /*#__PURE__*/React.createElement("hr", {
    className: "hr-separator hr-separator--light hr-separator--large-margin"
  }), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section  request-schedule__invite-info"
  }, "A zoom meeting has not been created yet until you click confirm. You can update the email in this window to update the invitations default before sending it out"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Team"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "invite-expert__note"
  }, "Make sure to select your team, the event will be added to team calendar!"), /*#__PURE__*/React.createElement(Select, {
    classNamePrefix: "teamInput",
    defaultValue: selectedTeam,
    onChange: e => dispatch({
      type: 'UPDATE',
      payload: {
        selectedTeam: e
      }
    }),
    options: activeTeams
  }), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section request-schedule__team-select-error",
    style: {
      display: selectedTeam ? 'none' : 'flex'
    }
  }, "A team must be selected to continue."))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "To client contacts"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, /*#__PURE__*/React.createElement(TagsInput, {
    value: clientContacts,
    itemToString: item => item && item.fullName,
    options: clientContactOptions,
    onChange: contacts => {
      dispatch({
        type: 'UPDATE',
        payload: {
          clientContacts: contacts
        }
      });
    },
    debounce: 500
  }))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "To additional emails"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer",
    style: {
      lineHeight: '24px'
    }
  }, /*#__PURE__*/React.createElement(TagsInput, {
    value: additionalEmailsClient,
    creatable: true,
    placeholder: "Type or select company",
    itemToString: item => item.fullName,
    itemFromCreatable: email => validateAdditionalEmails(email),
    loadOptions: query => employeeApi.typeaheadSearch(employeePositions, query),
    onChange: e => dispatch({
      type: 'UPDATE',
      payload: {
        additionalEmailsClient: e
      }
    }),
    debounce: 500
  }), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section request-schedule__team-select-error",
    style: {
      display: additionalEmailsValid ? 'none' : 'flex'
    }
  }, "All additional contacts must include a valid email address."))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Subject"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    className: "expert-form__input",
    name: "expertInvite",
    value: clientSubject,
    onChange: e => dispatch({
      type: 'UPDATE',
      payload: {
        clientSubject: e.target.value
      }
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Location"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, /*#__PURE__*/React.createElement("input", {
    className: "expert-form__input",
    name: "expertInvite",
    value: meetingType !== 'Zoom' ? locationClient : zoomLocationClient,
    onChange: e => {
      const dataToUpdate = {};

      if (meetingType === 'Zoom') {
        dataToUpdate.zoomLocationClient = e.target.value;
      } else {
        dataToUpdate.locationClient = e.target.value;
      }

      dispatch({
        type: 'UPDATE',
        payload: {
          zoomLocationClient: e.target.value
        }
      });
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Starts on"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, formatDateTime(schedule.timeslots[0].time.start))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Ends on"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, formatDateTime(schedule.timeslots[0].time.start + 1000 * 60 * schedule.timeslots[0].duration))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Message"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${isFocused ? 'rich-text-wrapper--focused rich-text-wrapper--toolboxActive' : ''} left-text rich-text-wrapper `
  }, /*#__PURE__*/React.createElement("div", {
    className: `client-text-wrapper left-text rich-text-wrapper ${focused}`
  }, /*#__PURE__*/React.createElement(FroalaEditor, {
    tag: "textarea",
    config: config,
    model: clientText,
    onModelChange: value => setClientText(value)
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "m-t-lg"
  }, pdfAttachSupported && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
    value: isExpertPdfChecked,
    label: "Attach expert profile as PDF",
    onChange: () => {
      isExpertPdfChecked = !isExpertPdfChecked;
      dispatch({
        type: 'UPDATE',
        payload: {
          attachExpertProfilePdf: isExpertPdfChecked
        }
      });
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "m-t-lg"
  }, !screeningSupported && /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 10
    }
  }, "Screening questions are not supported on this template"), screeningSupported && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
    value: isScreeningChecked,
    disabled: !allowAttachExpertScreeningQuestions,
    label: "Attach expert Screening Questions",
    onChange: () => {
      isScreeningChecked = !isScreeningChecked;
      dispatch({
        type: 'UPDATE',
        payload: {
          attachExpertScreeningQuestions: isScreeningChecked
        }
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '10px',
      display: allowAttachExpertScreeningQuestions ? 'none' : 'flex'
    }
  }, "This option is disabled because: (1) The screening question text for the EPL has not been set, or ", /*#__PURE__*/React.createElement("br", null), "(2) The screening question has been set to be hidden from the client"))), /*#__PURE__*/React.createElement("div", {
    className: "m-t-lg",
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '10px'
    }
  }, "This is a calendar invite for client contacts on the project. ", /*#__PURE__*/React.createElement("br", null), ' ', "Your team calendar will be updated as well.")), /*#__PURE__*/React.createElement("hr", {
    className: "hr-separator hr-separator--light hr-separator--large-margin"
  }), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__controls__inner"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button button--primary fullOnMobile responsiveMargin",
    onClick: () => {
      // must select a team to continue and all additional contacts have to be valid
      if (!formIsValid) return;
      dispatch({
        type: 'UPDATE',
        payload: {
          sendZoomUpdate: !sendZoomUpdateClient,
          expertZone: {
            timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
            displayLabel: 'Expert'
          },
          ExpertOffsetSet: false,
          clientMessage: clientText,
          quickInviteClient: !quickInviteClient,
          inviteClient: true,
          currentPath: lastPath,
          lastPath: '',
          clientinviteEdited: 'client',
          clientMessageUpdated: initClientText !== clientText
        }
      });
    }
  }, "Send calendar invitation"), showSkipClient && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button button--secondary fullOnMobile",
    onClick: async () => {
      // must select a team to continue and all additional contacts have to be valid
      if (!formIsValid) return;
      dispatch({
        type: 'UPDATE',
        payload: {
          currentPath: lastPath,
          lastPath: '',
          skipInviteClient: true,
          quickInviteClient: !quickInviteClient,
          sendZoomUpdate: !sendZoomUpdateClient,
          clientMessage: clientText,
          ExpertOffsetSet: false,
          expertZone: {
            timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
            displayLabel: 'Expert'
          }
        }
      });
    }
  }, "Only add to team calendar")), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button button--secondary button button--secondary",
    onClick: () => {
      // must select a team to continue and all additional contacts have to be valid
      if (!formIsValid) return;
      dispatch({
        type: 'UPDATE',
        payload: {
          quickUpdateClient: false,
          ExpertOffsetSet: false,
          currentPath: lastPath,
          lastPath: '',
          clientinviteEdited: '',
          quickInviteClient: false,
          expertZone: {
            timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
            displayLabel: 'Expert'
          }
        }
      });
    }
  }, "Skip calendar invitation")), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section request-schedule__team-select-error",
    style: {
      display: selectedTeam ? 'none' : 'flex'
    }
  }, "A team must be selected to continue."), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section request-schedule__team-select-error",
    style: {
      display: additionalEmailsValid ? 'none' : 'flex'
    }
  }, "All additional contacts must include a valid email address."));
};